import { Component, ReactNode } from 'react';
import { Error } from './Error';

import * as Sentry from '@sentry/browser';

type Props = {
  children: ReactNode;
};

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error) {
    if (process.env.NODE_ENV === 'production') {
      Sentry.captureException(error);
    }
  }

  public render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <Error />;
    }

    return children;
  }
}
